export default __webpack_public_path__ + "static/media/register_background.11b9f726.jpg";